import FAQ from 'components/slices/faq'
import Tent from 'images/Takibi Tent Chair Illustration.png'
import { Section } from 'components/common/common_styles'
import { MainContainer, Illustration } from './faqContainer_styles'

const FAQContainer = ({ data, washi }) =>
  <Section washi={washi}>
    <MainContainer padTop={[6, 3]} padBottom={1} padLeft padRight>
      <FAQ data={data} />
      <Illustration src={Tent} alt='' />
    </MainContainer>
  </Section>

export default FAQContainer
